<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="actionUrl"
  id="puzzleForm"
  :reset="true"
  v-on:submit.prevent="submit"
>
  <!-- // [WIP]
  <h4>Upload New Puzzle Source File</h4>

  <puzzle-upload-file
    :isRequired="puzzleUploadRequired"
    v-on:source-file-not-player-compatible="onSourceFileChange"
  ></puzzle-upload-file>
  -->

  <h4>Puzzle Publishing Options</h4>

  <div
    class="form-group row"
    v-if="id"
  >
    <div class="col-sm-2">
      <label
        for="puzzle-name"
      >
        Puzzle Title
      </label>
    </div>
    <div class="col">
      <input
        type="text"
        id="puzzle-name"
        class="form-control"
        name="puzzles[name]"
        v-model="name"
        required
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-2">
      <label
        for="puzzle-date"
      >
        Publish Date
      </label>
    </div>
    <div class="col-sm-4">
      <input
        type="date"
        name="puzzles[date]"
        id="puzzle-date"
        class="form-control"
        required="true"
        v-model="formattedDate"
      />
    </div>
    <div class="col">
      <!--
      <div class="form-check">
        <label class="form-check-label" for="puzzle-active">
          <input type="hidden" name="puzzles[active]" value="false" />
          <input
            type="checkbox"
            name="puzzles[active]"
            id="puzzle-active"
            class="form-check-input"
            v-model="active"
          />
          Active?
        </label>
      </div>
      -->
      <div class="form-check">
        <label class="form-check-label" for="puzzle-public">
          <input type="hidden" name="puzzles[public]" value="false" />
          <input
            type="checkbox"
            name="puzzles[public]"
            id="puzzle-public"
            class="form-check-input"
            v-model="public"
          />
          Public?
        </label>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-2">
      <label for="puzzle-difficulty">
        Difficulty Level (Between 1-100)
      </label>
    </div>
    <div class="col-10">
      <input
        type="number"
        name="puzzles[difficulty]"
        id="puzzle-difficulty"
        class="form-control"
        v-model="difficulty"
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-sm-2">
      <label
        class="form-label"
        for="provider"
      >
        <router-link
          :to="{
            name: 'providers'
          }"
        >
          Puzzle Type
        </router-link>
      </label>
    </div>
    <div class="col">
      <provider-picker
        selectName="puzzles[puzzle_link_id]"
        required="true"
        :providerId="provider_id"
      />
    </div>
  </div>

  <hr />

  <div
    id="contributors"
    class="d-flex justify-content-between"
  >
    <puzzle-editors-picker
      action="getAvailableContributors"
      inputName="puzzles[editor_ids][]"
      :selectedUserIds="editorIds"
      usersLbl="Editors"
      v-on:users-changed="editorsChanged"
    />

    <puzzle-authors-picker
      action="getAvailableContributors"
      inputName="puzzles[author_ids][]"
      :selectedUserIds="authorIds"
      usersLbl="Authors"
      v-on:users-changed="authorsChanged"
    />
  </div>

  <hr />

  <!--
  <tag-select
    type="puzzles"
    :selectedTags="tagSlugs"
  />

  <hr />
  -->

  <h4>Puzzle Purchase Options</h4>

  <div class="form-group row">
    <div class="col-sm-2">
      <label
        class="form-label"
        for="provider"
      >
        Purchase Data
      </label>
    </div>
    <div
      class="col"
    >
      <router-link :to="{
        name: 'purchasable_item',
        params: {
          purchasableItemId: this.purchasable_item.id
        }
      }" v-if="this.purchasable_item">
        Purchasable Item #{{ purchasable_item.id }}
      </router-link>
    </div>
  </div>

  <hr />

  <h4>Puzzle Attachments</h4>

  <div
    class="alert alert-warning text-center"
    role="alert"
    v-if="purchasable_item"
  >
    <p>
      One Shot PDFs should be uploaded as a <cite>Purchasable Item attachment</cite>.
    </p>

    You can do so by selecting <cite>Purchasable Item #{{ purchasable_item.id }}</cite> above once you've edited this puzzle.
  </div>

  <div class="form-group" v-if="attachments">
    <ol v-if="attachments.length">
      <li v-for="attachment in attachments">
        {{ attachment.name }}

        <span
          class="badge badge-sm badge-primary"
        >
          {{ Math.ceil(attachment.byte_size / 1024) }}kb
        </span>
        <span
          class="badge badge-sm badge-info"
        >
          {{ $root.displayDateTimeFmt(attachment.updated_at) }}
        </span>

        <label>
          Delete?
        </label>
        <input
          type="checkbox"
          name="puzzles[delete_attachments][]"
          :value="attachment.id"
        />

        <span class="badge badge-warning" v-if="attachment.auto_generated">
          Auto-Generated
        </span>
      </li>
    </ol>

    <div id="puzzle-attachments">
      <label for="puzzle-attachment">
        Add an Attachment
          <button class="btn btn-default" v-on:click="newAttachment">
            <strong>+</strong>
          </button>
      </label>
      <div>
        <input
          type="file"
          name="puzzles[attachment_files][]"
          class="puzzle-attachment"
          style="display: none;"
        />
      </div>
    </div>
  </div>

  <div class="form-group">
    <button
      type="submit"
      class="btn btn-primary form-control"
    >
      Edit Puzzle
      <spinner size="small" v-if="loading"></spinner>
    </button>
  </div>

  <div class="form-group" v-if="this.$parent.$parent.admin">
    <button
      type="button"
      class="btn btn-danger form-control"
      v-on:click.prevent="destroy"
    >
      Delete Puzzle
      <spinner size="small" v-if="loading"></spinner>
    </button>

    <div class="alert alert-warning text-center" role="alert">
      <p>
        Please note: deleting a puzzle <strong>will detach it</strong> from any pre-existing emails, newsletters, and purchases.
      </p>

      However, uploading a new puzzle with the same date will attach that puzzle to any prior puzzle-less purchases.
    </div>
  </div>

</form>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import ProviderPicker from '@/components/ProviderPicker'
import PuzzleUploadFile from '@/components/PuzzleUploadFile'
import UserPicker from '@/components/UserPicker'

import FlashStore from '@/stores/FlashStore'
import PuzzleStore from '@/stores/PuzzleStore'

import TagSelect from '@/components/TagSelect'

import TagMixin from '@/mixins/TagMixin'

export default {
  data () {
    return PuzzleStore.state
  },

  computed: {
    actionUrl () {
      return this.apiUrl('/admin/puzzles' + (this.id ? ('/' + this.id) : ''))
    },

    authorIds () {
      return this.authors.map(author => author.id)
    },

    contributorIds () {
      return this.contributors.map(contributor => contributor.id)
    },

    editorIds () {
      return this.editors.map(editor => editor.id)
    },

    formattedDate: {
      get () {
        return this.$root.dateFmt(this.date)
      },

      set (val) {
        const newStr = this.$root.setDate(val)
        this.date = newStr
      }
    },

    methodType () {
      return this.id ? 'PUT' : 'POST'
    },

    settings () {
      return this.$store.getters['SettingModule/settingsObject']
    }
  },

  components: {
    'provider-picker': ProviderPicker,
    'puzzle-authors-picker': UserPicker,
    'puzzle-editors-picker': UserPicker,
    'puzzle-upload-file': PuzzleUploadFile,
    'spinner': Spinner,
    'tag-select': TagSelect
  },

  mixins: [
    TagMixin
  ],

  props: ['method', 'action', 'puzzleUploadRequired'],

  mounted () {
    this.$store.dispatch(
      `SettingModule/getSettings`
    ).catch(this.$root.processErrors)
  },

  methods: {
    authorsChanged (authorIds) {
      this.author_ids = authorIds
    },

    editorsChanged (editorIds) {
      this.editor_ids = editorIds
    },

    onSourceFileChange (ev) {
      console.log('SOURCE FILE CHANGE')
      console.log(ev)
    },

    destroy () {
      // Ensure that the user is absolutely sure they want to delete the puzzle.
      if (
        confirm(
          'Are you sure you want to delete this puzzle? This will remove the puzzle from all emails, newsletters, and purchases.'
        )
      ) {
        if (confirm(
            'Please confirm one more time that you want to delete this puzzle. This cannot be undone.'
          )
        ) {
          this.loading = true
          this.$http.delete(this.apiUrl('/puzzles/' + this.id, true)).then((resp) => {
            this.loading = false

            FlashStore.result('Puzzle #' + this.puzzleId + 'has been permanently deleted.')

            this.$router.push({
              name: 'puzzles'
            })
          }, (resp) => {
            this.loading = false
            this.processErrors(resp)
          })
        }
      }
    },

    submit (ev) {
      this.loading = true

      this.bindSubmit(ev).then((response) => {
        this.loading = false
        const puzzleId = response.body.data.id

        FlashStore.result('Your changes have been saved.')

        this.$router.push({
          name: 'puzzle',
          params: {
            puzzleId: puzzleId
          }
        })
      }, (resp) => {
        this.loading = false
        this.$root.processErrors(resp)
      })
    },

    newAttachment (e) {
      e.preventDefault()

      let attach = document.querySelectorAll('.puzzle-attachment')[0].cloneNode()
      attach.style.display = 'inline-block'
      document.querySelector('#puzzle-attachments').appendChild(attach)
    },

    watch: {
      '$route' (to, from) {
        this.get()
      }
    }
  }
}

</script>

<style scoped>
.auto-generated {
  background-color: #F5EB8F
}

.reimportable {
  background-color: #F5B9A2;
  font-weight: 700;
}

#contributors {
  display: flex;
  justify-content: space-around;
}

</style>



// WEBPACK FOOTER //
// src/components/PuzzleForm.vue